import React, { Component } from 'react';
import styles from './Table2.module.css';
import { restructureResponse,generateEmptyResponse } from '../../helpers/sparql';

// import { Table as StrapTable } from 'reactstrap';

function camelCaseToSpaces(str) {
  str = str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ').toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}

class TableRow extends Component {
  onClick = uri => {
    try {
      eval(this.props.onClick);
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      this.props.publish(this.props.publishVariable, uri);
    }, 0);
   // console.log(uri);
  };

  render() {
    let valueObject = this.props.valueObject;
    let index = this.props.index;
    return (
         <tr className={index !== undefined ? styles.list : ''}>
        <td>{!index && camelCaseToSpaces(this.props.headVar)}</td>
        {valueObject.link ? (
          <td className={styles.link} onClick={() => this.onClick(valueObject.link)}>
            {valueObject.value}
          </td>
        ) : (
          <td>{valueObject.value}</td>
        )}
      </tr>
    );
  }
}

class Table2 extends Component {

  createStateValues(items)
  {
    let res = {};
    for (var i = 0; i < items.length; i++) {
      let item = items[i];
      Object.keys(item).forEach(key => {
        if (key.endsWith('URI')) return;
        let obj = { value: item[key] };
        if (item[key + 'URI']) obj.link = item[key + 'URI'];
        if (!res[key]) {
          res[key] = obj;
        } else if (Array.isArray(res[key])) {
          if (!res[key].filter(re => re.value === obj.value).length) {
            res[key].push(obj);
          }
        } else if (res[key].value !== item[key]) {
          res[key] = [res[key], obj];
        }
      });
    }

    Object.keys(res).forEach(key => {
      if (Array.isArray(res[key])) {
        res[key].sort((a, b) => a.value.localeCompare(b.value));
      }
    });
      
   return res;
   
  }

  render() {
    let data = this.props.data;

    if (!data || data.results.bindings.length === 0) {
      if (this.props.renderEmpty) {
        data = generateEmptyResponse(this.props.query);
      } else {
        return null;
      }
    }

    let items = restructureResponse(data);
    if (!items.length) return null;
    let valuesObj = this.createStateValues(items);

    return (
      <div className={styles.main + (this.props.isFirstItemBold ? ' ' + styles.firstItemBold : '')}>
        {this.props.title && <div className={styles.title}>{this.props.title}</div>}
        <table>
          {/* <thead>
          <tr>
            {data.head.vars.map((headVar, index) => (
              <th key={index}>{headVar}</th>
            ))}
          </tr>
        </thead> */}
          <tbody>
            {data.head.vars.map(headVar => {
              if (headVar.endsWith('URI')) {
                return null;
              }
              let valueObject = valuesObj[headVar];
              //if (!valueObject) return null;
              if (!valueObject) valueObject = '';

              if (Array.isArray(valueObject)) {
                return valueObject.map((val, index) => {
                  return <TableRow {...this.props} key={index} index={index} valueObject={val} headVar={headVar} />;
                });
              } else {
                return <TableRow key={headVar} {...this.props} index={0} valueObject={valueObject} headVar={headVar} />;
              }
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default Table2;
